// Stub for StateManager — xtracker implements its own undo/redo at the UI layer.
// The engine's editor.js expects create*Undo() to return an editAction object
// with a .name property and a .notes array (addNote pushes into it).
var StateManager = function(){
	var me = {};
	function makeEditAction(name) {
		return { name: name || "edit", notes: [], undo: function(){}, redo: function(){} };
	}
	me.addNote = function(editAction, track, row, note){
		if (editAction && editAction.notes) {
			editAction.notes.push({ track: track, row: row, note: note });
		}
	};
	me.clear = function(){};
	me.createNoteUndo = function(){ return makeEditAction("Note"); };
	me.createPatternUndo = function(){ return makeEditAction("Pattern"); };
	me.createTrackUndo = function(){ return makeEditAction("Track"); };
	me.registerEdit = function(){};
	return me;
}();

export default StateManager;
